import { render, staticRenderFns } from "./CertificadoQR.vue?vue&type=template&id=4dada75d&scoped=true"
import script from "./CertificadoQR.vue?vue&type=script&lang=js"
export * from "./CertificadoQR.vue?vue&type=script&lang=js"
import style0 from "./CertificadoQR.vue?vue&type=style&index=0&id=4dada75d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dada75d",
  null
  
)

export default component.exports